'use client';

import dynamic from 'next/dynamic';

import {
  contentGutterClass,
  originalPlusFaqItems,
  originalPlusFaqSectionId,
} from '@/features/original-plus/constants';

const KonkursQuestions = dynamic(
  () =>
    import('@/components/konkurs/konkurs-questions').then((module) => ({
      default: module.KonkursQuestions,
    })),
  {
    ssr: false,
    loading: () => (
      <div className="mx-auto min-h-[280px] w-full max-w-[800px] animate-pulse rounded-[10px] bg-[#1B1D22]/60" />
    ),
  },
);

export function OriginalPlusFaqSection() {
  return (
    <section
      id={originalPlusFaqSectionId}
      className={`${contentGutterClass} pb-16 pt-[70px] md:pb-24 md:pt-[120px]`}
      aria-label="Частые вопросы"
    >
      <KonkursQuestions items={originalPlusFaqItems} embedded />
    </section>
  );
}
